// Feature definitions.
// `beta: false` — visible only to CleverApps support users.
// `beta: true`  — promoted; visible to all users.
// `group`       — optional label. For support users, features sharing a group
//                 render under a parent checkbox that toggles all at once.
// `labelKey`    — translation key from the main navigation for the underlying
//                 feature. Rendered at runtime as "<translated label> *".
//                 The trailing asterisk marks the row as a new version of the
//                 menu entry without forcing a prefix that would inflect
//                 incorrectly in some languages.
// `label`       — fallback literal label when the feature has no menu entry
//                 (e.g. non-navigation features). Not translated.
// When no features are visible for the current user, the "Try New Features"
// menu entry is hidden.
var FEATURE_DEFINITIONS = [
    { key: 'devFeature_reactBrandView', labelKey: 'article.brand', beta: false, group: 'React Views' },
    { key: 'devFeature_reactCompanyView', labelKey: 'contacts.companies', beta: false, group: 'React Views' },
    { key: 'devFeature_reactUserView', labelKey: 'contacts.users', beta: false, group: 'React Views' },
    { key: 'devFeature_reactLocationView', labelKey: 'contacts.locations', beta: false, group: 'React Views' },
    { key: 'devFeature_reactAccountView', labelKey: 'role.account', beta: false, group: 'React Views' },
    { key: 'devFeature_reactCurrencyView', labelKey: 'base.currencies', beta: false, group: 'React Views' },
    { key: 'devFeature_reactCustomerGroupView', labelKey: 'role.customerGroup', beta: false, group: 'React Views' },
    { key: 'devFeature_reactArticleTypeView', labelKey: 'article.articletypes', beta: false, group: 'React Views' },
    { key: 'devFeature_reactPaymentTypeView', labelKey: 'role.paymentType', beta: false, group: 'React Views' },
    { key: 'devFeature_reactReturnReasonView', labelKey: 'role.returnReason', beta: false, group: 'React Views' },
    { key: 'devFeature_reactShippingMethodView', labelKey: 'role.shippingMethod', beta: false, group: 'React Views' },
    { key: 'devFeature_reactPaymentTermView', labelKey: 'role.paymentTerm', beta: false, group: 'React Views' },
    { key: 'devFeature_reactDeliveryTermView', labelKey: 'role.deliveryTerm', beta: false, group: 'React Views' },
    { key: 'devFeature_reactCountryView', labelKey: 'base.countries', beta: false, group: 'React Views' },
    { key: 'devFeature_reactDepartmentView', labelKey: 'article.department', beta: false, group: 'React Views' },
    { key: 'devFeature_reactSubCategoryView', labelKey: 'article.subcategory', beta: false, group: 'React Views' },
    { key: 'devFeature_reactIntrastatView', labelKey: 'article.intrastats', beta: false, group: 'React Views' },
    { key: 'devFeature_reactBusinessAreaView', labelKey: 'role.businessArea', beta: false, group: 'React Views' },
    { key: 'devFeature_reactVolumeDiscountView', labelKey: 'role.volumeDiscount', beta: false, group: 'React Views' },
    { key: 'devFeature_reactPsychologicalPriceView', labelKey: 'article.psychologicalprices', beta: false, group: 'React Views' },
    { key: 'devFeature_reactInvoiceTypeView', labelKey: 'role.invoiceType', beta: false, group: 'React Views' },
    { key: 'devFeature_reactVatView', labelKey: 'role.vat', beta: false, group: 'React Views' },
    { key: 'devFeature_reactDeliveryPlanningTemplateView', labelKey: 'base.deliveryplanningtemplates', beta: false, group: 'React Views' },
    { key: 'devFeature_reactOrderTypeView', labelKey: 'base.ordertypes', beta: false, group: 'React Views' },
    { key: 'devFeature_assortmentPlanning', labelKey: 'order.assortmentPlanning', beta: false },
    { key: 'devFeature_salesComparisonReport', label: 'Försäljning DS — Jämförelse', beta: false }
];

// @ngInject
function devFeaturesDialogService($uibModal, $rootScope) {
    return {
        showDialog: showDialog,
        getVisibleFeatures: getVisibleFeatures,
        hasVisibleFeatures: hasVisibleFeatures,
        isFeatureVisible: isFeatureVisible,
        isSupportUser: isSupportUser
    };

    function isSupportUser() {
        var user = $rootScope.currentUser;
        if (!user) return false;
        return user.firstName === "CleverApps" &&
            (user.lastName === "Superuser" ||
                user.lastName === "Support" ||
                user.lastName === "Thomas Sverker") &&
            (user.username === "superuser" ||
                user.username === "support" ||
                user.username === "thsv");
    }

    function getVisibleFeatures() {
        var isSupport = isSupportUser();
        return FEATURE_DEFINITIONS.filter(function (f) {
            return isSupport || f.beta === true;
        });
    }

    function hasVisibleFeatures() {
        return getVisibleFeatures().length > 0;
    }

    function isFeatureVisible(key) {
        return getVisibleFeatures().some(function (f) { return f.key === key; });
    }

    function showDialog() {
        var modalDefaults = {
            backdrop: 'static',
            keyboard: true,
            controller: 'devFeaturesDialogController as vm',
            templateUrl: 'main/devFeaturesDialog/devFeaturesDialog.tpl.html',
            size: 'sm'
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function devFeaturesDialogController($uibModalInstance, devFeaturesDialogService, $translate) {
    var vm = this;

    vm.isSupport = devFeaturesDialogService.isSupportUser();

    var visible = devFeaturesDialogService.getVisibleFeatures().map(function (def) {
        var label;
        if (def.labelKey) {
            label = $translate.instant(def.labelKey) + ' *';
        } else {
            label = def.label;
        }
        return {
            key: def.key,
            label: label,
            group: def.group,
            enabled: localStorage.getItem(def.key) === 'true'
        };
    });

    if (vm.isSupport) {
        var grouped = buildGroups(visible);
        vm.groups = grouped.groups;
        vm.standalone = grouped.standalone;
    } else {
        // Non-support users see a flat list; no group aggregate toggle.
        vm.groups = [];
        vm.standalone = visible;
    }

    vm.toggle = toggle;
    vm.toggleGroup = toggleGroup;
    vm.groupState = groupState;
    vm.close = close;

    function buildGroups(features) {
        var groupMap = {};
        var groups = [];
        var standalone = [];

        features.forEach(function (f) {
            if (f.group) {
                if (!groupMap[f.group]) {
                    var g = { name: f.group, features: [] };
                    groupMap[f.group] = g;
                    groups.push(g);
                }
                groupMap[f.group].features.push(f);
            } else {
                standalone.push(f);
            }
        });

        return { groups: groups, standalone: standalone };
    }

    function toggle(feature) {
        feature.enabled = !feature.enabled;
        localStorage.setItem(feature.key, feature.enabled ? 'true' : 'false');
    }

    function toggleGroup(group) {
        var newValue = groupState(group) !== 'all';
        group.features.forEach(function (f) {
            if (f.enabled !== newValue) {
                f.enabled = newValue;
                localStorage.setItem(f.key, newValue ? 'true' : 'false');
            }
        });
    }

    function groupState(group) {
        var enabledCount = group.features.filter(function (f) { return f.enabled; }).length;
        if (enabledCount === 0) return 'none';
        if (enabledCount === group.features.length) return 'all';
        return 'some';
    }

    function close() {
        $uibModalInstance.close();
    }
}

angular
    .module('devFeaturesDialog', [])
    .factory('devFeaturesDialogService', devFeaturesDialogService)
    .controller('devFeaturesDialogController', devFeaturesDialogController);
